import { z } from "zod";

export const FontSchema = z.object({
  label: z.string(),
  style: z.string(),
  url: z.string().optional(),
});

export const FontsSchema = z.array(FontSchema);
